import React from "react";
import {
  Box,
  Paper,
  Typography,
  Badge,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import TuneIcon from "@mui/icons-material/Tune";
import countryJson from "../../utils/countries.json";
import { useLocation } from "react-router-dom";
interface MobileSearchBarProps {
  searchClick: () => void;
  searchClick2: () => void;
  filterCount: number;
}
const MobileSearchBar: React.FC<MobileSearchBarProps> = ({
  searchClick,
  searchClick2,
  filterCount,
}) => {
  // const {
  //   selectedLocation,
  //   checkIn,
  //   checkOut,
  //   selectedBoatType,
  //   beds,
  //   localSearchData,
  // } = useSelector((state: RootState) => state.search);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const rawCheckIn = params.get("date_from") || "";
  const rawCheckOut = params.get("date_to") || "";
  const countryCode = params.get("country") || "";
  const boatType = params.get("yacht_type") || "";
  const beds = parseInt(params.get("bed") || "0");
  const city = params.get("city") || "";

  const checkInFormatted = rawCheckIn
    ? moment(rawCheckIn).startOf("day").format("D/M/YYYY")
    : "";
  const checkOutFormatted = rawCheckOut
    ? moment(rawCheckOut).startOf("day").format("D/M/YYYY")
    : "";

  // 🧠 Get country name from the array using .find
  const matchedCountry = countryJson.find(
    (c) => c.code.toLowerCase() === countryCode.toLowerCase()
  );
  const countryName = matchedCountry ? matchedCountry.name : countryCode;
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      sx={{
        padding: "10px 20px 10px 20px ",
        margin: "0px 0px 0px 0px",
        background: "white",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: "50px",
          backgroundColor: "#f0f0f0",
          padding: "8px 16px",
          flexGrow: 1,
          minWidth: 0,
          cursor: "pointer",
        }}
        onClick={searchClick}
      >
        <SearchIcon sx={{ marginRight: 1, width: "34px", height: "34px" }} />

        <Box
          sx={{
            overflow: "hidden",
            minWidth: 0,
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            noWrap
            sx={{ maxWidth: "100%" }}
          >
            {city ? `${city}, ` : ""}
            {countryName || ""}
            {/* {selectedLocation
              ? selectedLocation?.city && selectedLocation.city + ", "
              : ""}
            {selectedLocation
              ? selectedLocation?.countryName && selectedLocation.countryName
              : "selectedLocation"} */}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            noWrap
            sx={{ maxWidth: "100%" }}
          >
            {checkInFormatted || "Check-in"}
            {checkOutFormatted ? ` · ${checkOutFormatted}` : ""}
            {beds ? ` · ${beds} beds` : ""}
            {boatType ? ` · ${boatType}` : ""}
            {/* {checkIn ? moment(checkIn).format("D/M/YYYY") : "checkenin"}·
            {beds ? beds : 0} · {selectedBoatType ? selectedBoatType.label : ""} */}
          </Typography>
        </Box>
      </Paper>

      {/* <IconButton
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "50%",
          padding: "8px",
        }}
        onClick={searchClick2}
      >
        <TuneIcon />
      </IconButton> */}
      <Badge
        badgeContent={filterCount}
        overlap="rectangular"
        sx={{
          "& .MuiBadge-badge": {
            color: "white",
            backgroundColor: "black",
            top: 4,
            right: 4,
            fontSize: "0.75rem",
            height: 18,
            minWidth: 18,
          },
        }}
      >
        <Box
          onClick={searchClick2}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            border: "1px solid black",
            borderRadius: "9999px",
            px: 1.5,
            py: "7px",
            cursor: "pointer",
            userSelect: "none",
          }}
        >
          <TuneIcon sx={{ fontSize: 20 }} />
          <Typography fontSize="14px" fontWeight={500}>Filters</Typography>
        </Box>
      </Badge>
    </Box>
  );
};

export default MobileSearchBar;
